import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainLayoutProvider from "./context/MainLayoutContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <MainLayoutProvider>
      <RouterProvider router={router} />
      <ToastContainer
        rtl
        stacked
        limit={2}
        closeOnClick={true}
        autoClose={4000}
        position="bottom-right"
      />
    </MainLayoutProvider>
  </QueryClientProvider>
);
